<template>
  <div>
    <b-modal id="modalEditAdditionalParameter" ref="modalEditAdditionalParameter" :title="$t('Additional parameter')" hide-footer size="lg">
      <div v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id !== 0" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
              {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Displayed name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.display_name" aria-describedby="inputFeedbackName" :state="editItem.display_name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
              {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Visible')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox v-model="editItem.visible"/>
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditAdditionalParameter')" size="lg"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (!this.editItem.display_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Displayed name fields is invalid'), 'Error')
        return
      }
      this.editItem.aparam_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_ADDITIONAL', this.editItem)
        : this.$store.dispatch('Settings/CREATE_ADDITIONAL', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ADDITIONAL')
          this.$refs.modalEditAdditionalParameter.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/additional/editModal.vue